import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NfcSelectProductPage } from './nfc-select-product.page';

const routes: Routes = [
  {
    path: '',
    component: NfcSelectProductPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NfcSelectProductPageRoutingModule {}
